import { useState, useEffect } from "react"
import { getDataApi } from "../services/apiService"
import DataTableComponent from "../components/DataTableComponent"
import Filters from "../components/filters/filters"
import { columnsCashReconciliations, config } from "../utils/cash-reconciliation-data"

let hasRendered = false

export const CashReconciliationsPage = () => {

    const [data, setData] = useState({
        rows: [],
        totalRows: 0,
    })
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
        sortDirection: null,
        sortField: null
    })
    const [filters, setFilters] = useState(config.filtersInterface)
    const [preferences, setPreferences] = useState(config.preferencesInterface)

    const getData = async () => {
        const response = await getDataApi(0, 
            'cashReconciliation', 
            pagination.perPage * (pagination.page -1), 
            pagination.perPage, 
            null, null, pagination.sortField, pagination.sortDirection, null, filters)
        if (response.result === 'ok')setData(prev => ({
            ...prev,
            totalRows: response.count,
            rows: response.data
        }))
    }

    useEffect(() => {
        if (hasRendered) getData()
        else hasRendered = true
    }, [filters, pagination])

    return (
        <div className="card">
            <div className="card-body">
                <Filters
					config={{
                        ...config,
                        rows: [
                            [
                                {role: 'layout', inner: 'ARQUEOS DE CAJA'},
                                [
                                    {key: 'update', action: getData},
                                ]
                            ],
                            ...config.rows
                        ]
                    }}
					onFilterChange={setFilters}
                    onPreferenceChange={setPreferences}
				/>
                <hr />
                <DataTableComponent 
                    title="Listado de Arqueos de caja"
                    columns={columnsCashReconciliations}
                    data={data.rows}
                    totalRows={data.totalRows}
                    onChangePage={e => setPagination(prev => ({...prev, page: e}))}
                    onChangeRowsPerPage={(perPage, page) => setPagination(prev => ({...prev, perPage, page}))}
                    onSort={({field: sortField}, sortDirection) => setPagination(prev => ({...prev, sortDirection, sortField}))}
                    loading={data.length === 0}
                    model="cashReconciliation"
                />
            </div>
        </div>
    )
}